import { sgiLogger } from "rt-sd-common/sgiCommon/sgiLogger";
import { getConstByKey, setFunction } from "./SgiCommon";

/**
 * 容器组件的公共方法，非组件继承方法
 * hanzb
 * 2019-8-7
 */

/**
 * 转换ctn公共属性（不参与继承，所以放外面）
 * @param {object} currentModule 当前module
 * @param {object} moduleDesc json描述
 * @param {object} ctnWrapProps ctn容器属性
 * @param {object} ctnHeadProps ctnhead属性
 * @param {object} ctnBodyProps ctnbody属性
 */
var addCtnCommonAttribute = function (currentModule, moduleDesc, ctnWrapProps, ctnHeadProps, ctnBodyProps) {
    var cId = moduleDesc.cId; //cid 唯一标示
    if (cId) ctnWrapProps.id = getConstByKey(currentModule, cId);

    var ctlW = moduleDesc.ctlW; //form宽度
    ctnWrapProps.style.width = ctlW;
    if (ctlW == 0 || ctlW == '0px') {
        ctnWrapProps.style.width = undefined;
    }

    var ctlH = moduleDesc.ctlH; //form高度
    ctnWrapProps.style.height = ctlH;
    if (ctlH == 0 || ctlH == '0px') {
        ctnWrapProps.style.height = undefined;
    }

    var isBrdr = moduleDesc.isBrdr; //form是否有边框??没实现
    if (isBrdr) {
        ctnWrapProps.style.border = "1px solid rgb(217, 217, 217)";/*边线宽度 类型 颜色*/;
    } else {
        ctnWrapProps.style.border = undefined;
    }

    var mgn = moduleDesc.mgn; //form外边距
    if (mgn) ctnWrapProps.style.margin = mgn;
    var pad = moduleDesc.pad; //form内边距
    if (pad) ctnWrapProps.style.padding = pad;

    var isHdn = moduleDesc.isHdn; //form是否隐藏
    if (isHdn) {
        ctnWrapProps.style.display = "none";
    } else {
        ctnWrapProps.style.display = undefined;
    }

    var isScl = moduleDesc.isScl; //form是否可以滚动
    if (isScl) {
        if (!ctnBodyProps) ctnWrapProps.style.overflow = "auto";
        if (ctnBodyProps) ctnBodyProps.style.overflow = "auto";
    } else {
        if (!ctnBodyProps) ctnWrapProps.style.overflow = undefined;
        if (ctnBodyProps) ctnBodyProps.style.overflow = undefined;
    }

    //公共属性里统一进行文本资源转换，各个控件可直接从ctnProps.te中取出结果，不再需要单独转换
    // if (moduleDesc.te || moduleDesc.teid) {//如果te和teid都不存在则不查找资源
    //     var te = Resource.getTRByPrm(moduleDesc).te; //显示名称
    //     if (te) ctnProps.te = te;
    // }
    var te = Resource.getTRByPrm(moduleDesc).te; //显示名称
    ctnWrapProps.te = te;

    // 初始加载中
    currentModule.state.loading = !!moduleDesc.loading;

    // 自定义样式
    let cstmStyle = moduleDesc.cstmStyle;
    let $cstmStyle;
    if (cstmStyle) {
        try {
            $cstmStyle = new Function("module", "objFct", cstmStyle);
        } catch (error) {
            sgiLogger.eventErr(error);
        }
        // currentModule.state.cstmStyle = $cstmStyle;
        setFunction(currentModule, "cstmStyle", $cstmStyle);
    }
}

export { addCtnCommonAttribute };
export default addCtnCommonAttribute;


// WEBPACK FOOTER //
// ./~/rt-sd-comp/sgiComp/sgiBaseComp/SgiCtnCommon.js